// Calendly popup — shared trigger handler (site-wide)
// Works with any element carrying a data-calendly-url attribute.
(function () {
  if (window.__calendlyPopupInit) return;
  window.__calendlyPopupInit = true;

  var BRAND_PRIMARY = 'd9b675';
  var BRAND_TEXT = '1e1b16';
  var BRAND_BG = 'ffffff';

  function withBrandColors(rawUrl) {
    try {
      var url = new URL(rawUrl, window.location.href);
      if (!url.searchParams.has('primary_color')) url.searchParams.set('primary_color', BRAND_PRIMARY);
      if (!url.searchParams.has('text_color')) url.searchParams.set('text_color', BRAND_TEXT);
      if (!url.searchParams.has('background_color')) url.searchParams.set('background_color', BRAND_BG);
      return url.toString();
    } catch (e) {
      return rawUrl;
    }
  }

  function openCalendly(rawUrl) {
    if (typeof window.Calendly === 'undefined' || !window.Calendly.initPopupWidget) {
      setTimeout(function () { openCalendly(rawUrl); }, 300);
      return;
    }
    window.Calendly.initPopupWidget({ url: withBrandColors(rawUrl) });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-calendly-url]');
    if (!trigger) return;
    event.preventDefault();
    openCalendly(trigger.getAttribute('data-calendly-url'));
  });

  // Lock body scroll while the popup is open, and clean up when it closes.
  var observer = new MutationObserver(function () {
    var isOpen = !!document.querySelector('.calendly-overlay');
    document.body.classList.toggle('calendly-open', isOpen);
    document.documentElement.classList.toggle('calendly-open', isOpen);
  });

  observer.observe(document.body, { childList: true });
})();